import React from 'react';
import { Helmet } from 'react-helmet';
import './Banner.css';
import bannerImage from '../images/b.png';

const Banner = () => {
  return (
    <>
      <Helmet>
        <title>
          Plastic Safety Eyes Manufacturer in India | Soft Toy Eyes Supplier Delhi | Pushkar Enterprises
        </title>

        <meta
          name="description"
          content="Leading plastic safety eyes manufacturer in India. Pushkar Enterprises supplies soft toy eyes, amigurumi eyes, teddy bear eyes & toy noses in bulk from Delhi."
        />

        <meta
          name="keywords"
          content="plastic safety eyes manufacturer India, soft toy eyes supplier Delhi, amigurumi eyes bulk, teddy bear eyes wholesale, toy noses manufacturer India"
        />

        <meta name="robots" content="index, follow" />

        <meta
          property="og:title"
          content="Plastic Safety Eyes Manufacturer in India | Pushkar Enterprises"
        />

        <meta
          property="og:description"
          content="Bulk supplier of soft toy eyes, amigurumi eyes & plush toy accessories. Trusted manufacturer based in Delhi."
        />

        <meta property="og:image" content={bannerImage} />
        <meta property="og:type" content="website" />
      </Helmet>

      <header
        className="banner"
        role="banner"
        aria-label="Plastic safety eyes manufacturer in India"
        style={{ backgroundImage: `url(${bannerImage})` }}
      >
        <div className="banner-overlay">
          <br />

          <p className="banner-subtext">
            25+ Years of Manufacturing Excellence in Soft Toy Accessories
          </p>

          {/* 🔥 MAIN SEO HEADING */}
          <h1 className="banner-title">
            Plastic Safety Eyes Manufacturer in India
            <br />
            Soft Toy Eyes & Noses Supplier in Delhi
          </h1>

          {/* 🔥 KEYWORD-RICH DESCRIPTION */}
          <p className="banner-description">
            Pushkar Enterprises is a trusted manufacturer of plastic safety eyes,
            teddy bear eyes, amigurumi eyes, and toy noses. We supply high-quality
            soft toy accessories in bulk to manufacturers and exporters across India
            and worldwide.
          </p>
        </div>
      </header>
    </>
  );
};

export default Banner;